class Rc {
  async _init() {
    _$.vue.$on("rc-command", e => this.run(e))
    return true
  }
  async run(e) {
    const keys = await __._device.getKeyMap().then(list => Object.fromEntries(list.map(item => item.reverse())))
    const { rc } = e

    switch (rc) {
      case "power-toggle":
        if (__.device.isPowerOn()) __.device.standBy()
        else __.device.powerOn()
        break
      case "sources":
        __.source.select()
        break
      case "mute":
        var mute = await __.device.mute()
        __.device.mute(!mute)
        break
      case "channel-list":
        __.platform.toPlatform()
        _$.nav.onKeyDown({ keyCode: keys.list }, false)
        break
      case "channel-up":
        _$.nav.onKeyDown({ keyCode: keys.ch_up }, false)
        break
      case "channel-down":
        _$.nav.onKeyDown({ keyCode: keys.ch_down }, false)
        break
      case "enter":
        _$.nav.onKeyDown({ keyCode: keys.enter }, false)
        break
      case "move-left":
        _$.nav.onKeyDown({ keyCode: keys.left }, false)
        break
      case "move-right":
        _$.nav.onKeyDown({ keyCode: keys.right }, false)
        break
      case "move-up":
        _$.nav.onKeyDown({ keyCode: keys.up }, false)
        break
      case "move-down":
        _$.nav.onKeyDown({ keyCode: keys.down }, false)
        break
      case "back":
        _$.nav.onKeyDown({ keyCode: keys.back }, false)
        break
      case "home":
        __.platform.toPlatform()
        _$.nav.onKeyDown({ keyCode: keys.home }, false)
        break
      case "volume-up":
        var volumeUp = await __.device.volume()
        if (__._device._volumeRange) volumeDown = Math.round((volumeUp / 100) * __._device._volumeRange)
        volumeUp = volumeUp + 3
        if (volumeUp > __.device.maxVolume) volumeUp = __.device.maxVolume
        __.device.volume(volumeUp)
        break
      case "volume-down":
        var volumeDown = await __.device.volume()
        if (__._device._volumeRange) volumeDown = Math.round((volumeDown / 100) * __._device._volumeRange)
        volumeDown = volumeDown - 3
        if (volumeDown < 0) volumeDown = 0
        __.device.volume(volumeDown)
        break
      default:
        if (rc?.startsWith("channel")) {
          var channel = rc.split("-").pop()
          _$.vue.$channelInstantWithID(channel)
        } else {
          console.log("Bilinmeyen Komut", rc)
        }
        break
    }
  }
}
export default new Rc()
